import React from "react";
import style from "./bracell-plant-count.module.css";

const OPTIONS = [5, 50];

function BracellPlantCountSelector({ value, onChange }) {
  return (
    <div className={style.card}>
      <div className={style.title}>Quantidade de plantas amostradas</div>
      <div className={style.buttons}>
        {OPTIONS.map((n) => (
          <button
            key={n}
            type="button"
            className={n === value ? style.active : style.btn}
            onClick={() => onChange(n)}
          >
            {n}
          </button>
        ))}
      </div>
    </div>
  );
}

export default BracellPlantCountSelector;
